import { Box } from '@deckee/deck-hand';
import React from 'react';

const Form: React.FC<{onSubmit: () => any}> = ({ onSubmit, ...rest }) => (
  <Box
    py="0"
    px="3"
    display="flex"
    flexDirection="column"
    alignItems="center"
    height="100%"
    as="form"
    onSubmit={onSubmit}
    {...rest}
  />
);

export default Form;
